import { createContext, useContext, useEffect } from 'react';
import noop from '@atlaskit/ds-lib/noop';
/**
 * Provides a way to register and unregister skip links
 */
export var SkipLinksContext = /*#__PURE__*/createContext({
  registerSkipLink: noop,
  unregisterSkipLink: noop
});
export var useSkipLinks = function useSkipLinks() {
  return useContext(SkipLinksContext);
};
export var useSkipLink = function useSkipLink(id, label, listIndex) {
  var _useSkipLinks = useSkipLinks(),
    registerSkipLink = _useSkipLinks.registerSkipLink,
    unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
  useEffect(function () {
    registerSkipLink({
      id: id,
      label: label,
      listIndex: listIndex
    });
    return function () {
      unregisterSkipLink(id);
    };
  }, [id, label, listIndex, registerSkipLink, unregisterSkipLink]);
};